<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
                <el-breadcrumb-item>班组考勤</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="main-left">
                <p class="main-left-p">
                    <span>共{{teams.length}}个班组</span>
                    <!-- <el-date-picker
                        v-model="teamSeach.date"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        style="width:70%;"
                        :picker-options="pickerOptions">
                    </el-date-picker> -->
                </p>
                <div class="main-left-search">
                    <!-- <el-input placeholder="请输入班组名称" v-model="teamSeach.teamsName" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="teamFilter"></el-button>
                    </el-input> -->
                    <el-date-picker
                        v-model="teamSeach.date"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        style="width:70%;"
                        :picker-options="pickerOptions"
                        @change="teamFilter">                        
                    </el-date-picker>
                    <el-popover
                        placement="right"
                        width="100"
                        trigger="click">
                        <div style="width:100%;">
                        <p v-for="item in sortList" :key="item.id" :class="{color5:teamSeach.sortings==item.id}" style="width:100%;height:40px;cursor: pointer;" @click="setSort(item.id)">{{item.name}}</p>
                        </div>
                        <el-button slot="reference" type="primary" icon="el-icon-sort" style="width:60px;height:40px;margin-left:20px;"></el-button>
                    </el-popover>
                </div>
                <div class="main-left-list">
                    <div class="team-item" @click="setTeamFun()" :class="{current:curTeam==''}">
                        <div class="team-item-div">
                            <p class="color1 nowrap" style="width:calc( 100% - 160px );text-align: left;padding-left:10px;">{{teamAll.teamsName}}</p>
                            <p class="color1" style="width:160px;text-align: right;">出勤率{{teamAll.cqlv}}%</p>
                        </div>
                        <div style="width:100%;height:30px;position: relative;display:flex;align-items: center;">
                        <p class="color3" style="width:33%;">在职：{{teamAll.zzCount}}</p>
                        <p class="color3" style="width:33%;">出勤：{{teamAll.cqCount}}</p>
                        <p class="color3" style="width:33%;">缺勤：{{teamAll.qqCount}}</p>
                        </div>
                    </div>
                    <div class="team-item" v-for="item in teams" :key="item.id" @click="setTeamFun(item.teamsId)" :class="{current:curTeam==item.teamsId}">
                        <div class="team-item-div">
                        <p class="color5 nowrap" style="width:calc( 100% - 120px );text-align: left;padding-left:10px;" :title="item.teamsName">{{item.teamsName}}</p>
                        <p class="color5" style="width:120px;">出勤率{{item.cqlv}}%</p>
                        </div>
                        <div class="team-item-div">
                        <p class="color3" style="width:33%;">在职：{{item.zzCount}}</p>
                        <p class="color3" style="width:33%;">出勤：{{item.cqCount}}</p>
                        <p class="color3" style="width:33%;">缺勤：{{item.qqCount}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-table">
                <div class="table-head">
                    <div class="table-head-seach">
                        <el-input placeholder="请输入姓名" v-model="tableDataName" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                        </el-input>
                      考勤计算：
                      <el-date-picker
                          v-model="referTime"
                          type="daterange"
                          align="right"
                          unlink-panels
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width:20vw"
                          @change="saveReferTime"
                      >
                      </el-date-picker>
                    </div>
                    <div>
                        <!-- 导出 -->
                        <!-- <el-button type="primary" plain style="display:flex;align-items:center" @click="addRow">导出</el-button> -->
                         <el-tooltip class="item" effect="dark" content="导出" placement="top-end" v-if="isMenuExit('pro:dayAttend:export')">
                            <img  style="height:30px" @click="addRow" src="../../assets/image/export.png" alt="" srcset="">
                        </el-tooltip>
                    </div>
                </div>
                <div class="table-box">
                    <el-table
                        :default-sort="{prop: 'date', order: 'descending'}"
                        :data="tableDataEnd"
                        :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                        height="100%"
                        style="width: 100%;"
                        >
                        <template slot="empty">
                            <p>{{dataText}}</p>
                        </template>
                        <el-table-column label="序号" width="80">
                            <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="班组">
                            <template slot-scope="scope">
                            <a>{{ scope.row.teamsName}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名">
                            <template slot-scope="scope">
                            <a>{{ scope.row.name}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column label="岗位">
                            <template slot-scope="scope">
                            <span>{{ scope.row.attendNum }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="首次打卡">
                            <template slot-scope="scope">
                            <span>{{ scope.row.amInTime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="末次打卡">
                            <template slot-scope="scope">
                            <span>{{ scope.row.pmOutTime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="出勤时长（小时）">
                            <template slot-scope="scope">
                            <span>{{ scope.row.workTime }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="操作">
                            <template slot-scope="scope">
                            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
export default {
    data(){
        return{
            referTime:'',
            groupId:'',
            teamId:'',//选择班组id
            teams:[],//表格左侧班组列表
            teamAll:{  //班组统计
                teamsName:'全部班组',
                cqCount: 0,
                qqCount: 0,
                teamsId: "",
                zzCount: 0,
                cqlv:0,
            },
            pickerOptions: { //时间插件参数
                disabledDate(time) {
                return time.getTime() > Date.now();
                },
                shortcuts: [{
                text: '今天',
                onClick(picker) {
                    picker.$emit('pick', new Date());
                }
                }, {
                text: '昨天',
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                }
                }, {
                text: '一周前',
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                }
                }]
            },
            teamSeach:{
                date:util.myTime.getCurTime(),
                teamsName:'',
                sortings:'1',//当前排序
                projectId:'',
            },
            curTeam:'',  //当前班组id
            sortList:[   //排序列表
                {id:'1',name:'出勤率降序'},
                {id:'2',name:'出勤率升序'},
                {id:'3',name:'班组名a-z'},
                {id:'4',name:'班组名z-a'},
            ],
            teamName:'',
            dataText:"数据加载中...",
            tableDataEnd: [],
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            tableDataName:'',//名称
            workerType:[],//工种列表
            managerType:[],//岗位列表
        }
    },
    mounted(){
        if(util.session.get('roleId')=='4'){
            this.groupId = util.session.get('groupId')
        }else{
            this.groupId = util.session.get('proId')
        }
        this.teamSeach.projectId = this.groupId
        this.getData();
        this.getTeam();
        this.getTypeDict('position')//获取岗位
        this.getTypeDict('worktype')//获取工种
    },
    methods:{
        saveReferTime(){
          console.log(this.referTime[0],this.referTime[1])
          var that = this
          myHttp.queryAttendTime({
            projectId:this.groupId,
            startTime:this.referTime[0],
            endTime:this.referTime[1]
          }).then(function (resp) {
            if(resp.data.code == '200') {

            }
          })
        },
        //班组查询
        teamFilter(){
            this.getData();
            this.getTeam();
        },
        //排序查询
        setSort(id){
            this.teamSeach.sortings = id
            //this.getTeam();
            if(id==1){
                this.teams.sort(util.common.createComprisonFunction('cqlv',0))
            }else if(id==2){
                this.teams.sort(util.common.createComprisonFunction('cqlv',1))
            }else if(id==3){
                this.teams.sort(util.common.ChinaComprisonFunction('teamsName',0))
            }else if(id==4){
                this.teams.sort(util.common.ChinaComprisonFunction('teamsName',1))
            }
        },
        getTeam(){
            var that = this;
            myHttp.getAttendNew(this.teamSeach).then(function(resp){
                if(resp.data.code=='200'){
                var list = resp.data.data.list||[]
                var all = {
                    teamsName:'全部班组',
                    cqCount: 0,
                    qqCount: 0,
                    teamsId: "",
                    zzCount: 0,
                    cqlv:0,
                }
                for(var i=0;i<list.length;i++){
                    if(list[i].zzCount && list[i].zzCount!=0){
                    list[i].cqlv = (parseInt(list[i].cqCount)/parseInt(list[i].zzCount)*100).toFixed(0)
                    }else{
                    list[i].cqlv = 0
                    }
                    all.cqCount += parseInt(list[i].cqCount)
                    all.qqCount += parseInt(list[i].qqCount)
                    all.zzCount += parseInt(list[i].zzCount)
                }
                if(all.zzCount > 0){
                    all.cqlv = (parseInt(all.cqCount)/parseInt(all.zzCount)*100).toFixed(1)
                }
                //list.unshift(all)
                that.teamAll = all
                that.teams = list
                }
            })
        },
        // 搜索数据
        doFilter() {
            this.getData()
        },
        // 获取数据
        getData() {
        var option = {
            teamsId:this.curTeam,
            projectId:this.groupId,
            date:this.teamSeach.date,
            personName:this.tableDataName
        }
        var that = this;
        myHttp.getTeamsAttend(option).then(function(resp){
            if(resp.data.code=="200"){
                var list = resp.data.data.list||[];
                for(var i=0;i<list.length;i++){
                if(list[i].amInTime && list[i].pmOutTime) {
                  const firstTime = new Date(list[i].amInTime).getTime()
                  const lastTime = new Date(list[i].pmOutTime).getTime()
                  list[i].workTime = ((lastTime - firstTime) / (1000*60*60)).toFixed(2)
                }else {
                  list[i].workTime = 0
                }
                list[i].index = i+1
                }
                that.tableDataEnd = list;
                that.getTypeName()
                if(that.tableDataEnd.length==0){
                that.dataText='暂无数据'
                }
            }else{
            that.$message.error(resp.data.msg);
            that.dataText='暂无数据'
            }
        },function(){});
        },
        //导出
        addRow(){
            var token = this.$store.state.token;
            window.open(myHttp.exportTeamsAttend+"?projectId=" + this.groupId + '&teamsId=' + this.curTeam + '&date=' + this.teamSeach.date + '&personName=' + this.tableDataName + '&accessToken='+token);
        },
        //详情
        handleEdit(index,row){
            let that = this
            setTimeout(function() {
                that.$router.push({
                name: 'productMan',
                params: { id: row.id, name: row.name, projectId: row.projectId }
                })
            }, 0)
        },
        /**
         * 选择班组
         */
        setTeamFun(id){
            this.curTeam = id?id:''
            this.getData();
        },

        //获取字典类型
        getTypeDict(type){
            var that = this
            myHttp.getDictByType({
            type: type
            }).then(function(resp) {
            if (resp.data.code == '200') {
                if(type=='position'){
                that.managerType = resp.data.data.dictList
                }else{
                that.workerType = resp.data.data.dictList
                }
                that.getTypeName()
            } else {
                that.$message.error(resp.data.msg)
            }
            }) 
        },
        //展示工种或者岗位
        getTypeName(){
            //var list = this.listData
            if(this.tableDataEnd.length==0){
                return;
            }
            for(var i=0;i<this.tableDataEnd.length;i++){
                if(this.tableDataEnd[i].teamsType=='1'){
                this.tableDataEnd[i].typeName = this.getNameById(this.tableDataEnd[i].workType,this.workerType)
                }else{
                this.tableDataEnd[i].typeName = this.getNameById(this.tableDataEnd[i].workType,this.managerType)
                }
            }
        },
        //获取数据名称
        getNameById(id,list){
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id == list[i].value){
                result = list[i].label
                }
            }
            return result
        },
        /**
         * 判断是否展示
         */
        isMenuExit(row){
            var flag = util.common.filterBtnMenu(row)
            return flag
        },
    }

}
</script>
<style scoped>
    /* .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
    } */
    .main-left{
        width: 18vw;
        height: 100%;
        position: relative;
        /* overflow: auto; */
        background: #fff;
        border-radius: 0.5vh;
    }
    .main-left-search{
        width: 100%;
        height: 8%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vh;
        justify-content: space-between;
    }
    .main-left-p{
        width: 100%;
        height: 8%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content:space-between;
        padding: 0 1vh;
    }
    .main-left-list{
        width: 100%;
        height: 83%;
        position: relative;
        overflow: auto;
    }
    .team-item{
        width:100%;
        height:80px;
        border-bottom: 1px solid #f1f0f0;
        padding: 10px 15px;
        cursor: pointer;
    }
    .team-item.current{
        background:rgba(241,251,255,1);
    }
    .team-item-div{
        width:100%;
        height:30px;
        position: relative;
        display:flex;
        align-items: center;
    }
    .main-table{
        width: calc( 100% - 18vw );
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
    }
    .table-head{
        width: 100%;
        height: 8vh;
        position: relative;
        background: #fff;
        border-top-left-radius: 0.5vh;
        border-top-right-radius: 0.5vh;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vh;
        justify-content: space-between;
    }
    .table-head-seach{
        width: 58%;
        height: 40px;
        position: relative;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
    }
    .table-box{
        width: 100%;
        height: calc( 100% - 8vh );
        position: relative;
        background: #fff;
        border-bottom-left-radius: 0.5vh;
        border-bottom-right-radius: 0.5vh;
    }
    .box-second >>>.el-input-group--append .el-input__inner{
        width: 200px;
    }
</style>
<style>
    @import '../../assets/css/common.css';
</style>